import React, { createContext } from 'react';
import 'mobx-react-lite/batchingForReactDom';
import initFormatNumeral from '../../services/numeralService';
import initMoment from '../../services/momentConfig';
import SeekerMessagesStore from '../seeker/seekerMessages.store';
import TourStoreRegister from '../../services/tourRegister';
import StoreTour from '../tour.store';

class LeadStore {
  SeekerMessagesStore = new SeekerMessagesStore();

  TourRegister = new TourStoreRegister();

  constructor() {
    this.TourRegister.register(new StoreTour('spamtour', false, [{ id: 'spam' }]));
    initFormatNumeral();
    initMoment();
  }
}

export const StoreContext = createContext({});

export default ({ children }) => {
  return <StoreContext.Provider value={{ ...new LeadStore() }}>{children}</StoreContext.Provider>;
};
